import { createSlice } from '@reduxjs/toolkit'
import { getDomainKey } from '../utils/dashboardUtils'
import { DashboardTypes } from 'features/Codes'

export const createTableSlice = ({
  type,
  initialState = {},
  reducers = {},
  extraReducers,
  fetcher,
  summaryFetcher,
}) => {
  const getInitialState = () => ({
    loaded: false,
    isLoading: false,
    summaryLoading: false,
    error: undefined,
    selectedIds: [],
    summary: {},
    extraSummary: {},
    content: [],
    sort: {
      name: type === DashboardTypes.KEYWORD ? 'text' : 'name',
      order: 'asc',
    },
    page: 0,
    totalElements: 0,
    ...initialState,
  })
  return createSlice({
    name: `dashboard/${type}Table`,
    initialState: getInitialState(),
    reducers: {
      reset: () => getInitialState(),
      toggleSelectedId: (state, { payload: id }) => {
        const index = state.selectedIds.indexOf(id)
        if (index === -1) {
          state.selectedIds.push(id)
        } else {
          state.selectedIds.splice(index, 1)
        }
      },
      setSelectedIds: (state, { payload: selectedIds }) => {
        state.selectedIds = selectedIds
      },
      setPage: (state, { payload: page }) => {
        state.page = page
      },
      setSort: (state, { payload: sort }) => {
        state.sort = sort
      },
      clearError: state => {
        state.error = undefined
      },
      setStatus: (state, { payload: result }) => {
        const key = getDomainKey(type)
        state.content.forEach(content => {
          const status = result[content[key]]
          if (status) {
            content.status = status
          }
        })
      },
      ...reducers,
    },
    extraReducers: builder => {
      builder.addCase(fetcher.pending, state => {
        state.isLoading = true
        state.summaryLoading = true
      })

      builder.addCase(
        fetcher.fulfilled,
        (state, { payload: { totalElements, content, error } }) => {
          state.totalElements = totalElements
          state.content = content
          const key = getDomainKey(type)
          state.selectedIds = state.selectedIds.filter(id =>
            content.find(item => item[key] === id)
          )
          state.error = error
          state.loaded = true
          state.isLoading = false
        }
      )

      builder.addCase(fetcher.rejected, (state, { payload, error }) => {
        const savingError = payload || error
        if (savingError?.name !== 'AbortError') {
          state.error = savingError
        }
        state.isLoading = false
      })

      builder.addCase(
        summaryFetcher.fulfilled,
        (state, { payload: { summary, extraSummary } }) => {
          state.summary = summary
          if (extraSummary) {
            state.extraSummary = extraSummary
          }
          state.summaryLoading = false
        }
      )

      if (extraReducers) {
        extraReducers(builder)
      }
    },
  })
}
